import React, { Component } from "react";
import FrontEndRoutes from "routes/FrontEndRoutes.jsx";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import logo from "assets/img/zabin-logo.jpg";
import logo_gray from "assets/img/logo_gray.png";
import { frontEndUserActions } from "../../../redux/actions/front-end-action";
import User from "../../../helper/User";

class HeaderPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            routes: ""
        };
        this.logout = this.logout.bind(this);
    }
    sortByColumn(a, colIndex) {
        a.sort(sortFunction);
        function sortFunction(a, b) {
            if (a[colIndex] === b[colIndex]) {
                return 0;
            } else {
                return a[colIndex] < b[colIndex] ? -1 : 1;
            }
        }
        return a;
    }

    logout() {
        this.props.dispatch(frontEndUserActions.logout());
    }
    render() {
        return (
            <header
                id="header"
                test={this.props.history.location.pathname}
                className={
                    this.props.history.location.pathname === "/Home" ||
                        this.props.history.location.pathname === "/"
                        ? ""
                        : "no_slider"
                }
            >
                {/*<nav className={'navbar navbar-default' + (this.props.history.location.pathname === '/Home' || this.props.history.location.pathname === '/'?' pos_abs':'')} role="navigation" data-spy="affix" data-offset-top="300">*/}
                <nav className="navbar navbar-default">
                    <div className="container">
                        <div className="navbar-header">
                            <button
                                type="button"
                                className="navbar-toggle"
                                data-toggle="collapse"
                                data-target=".navbar-ex1-collapse"
                            >
                                <span className="sr-only">
                                    Toggle navigation
                                </span>
                                <i className="fa fa-navicon"></i>
                            </button>

                            <a className="navbar-brand" href="/">
                                {this.props.history.location.pathname !==
                                    "/Home" &&
                                    this.props.history.location.pathname !==
                                    "/" && (
                                        <div>
                                            <img
                                                src={logo}
                                                className="default test1"
                                                alt="logo"
                                            />
                                            <img
                                                src={logo_gray}
                                                className="gray test2"
                                                alt="logoGrey"
                                            />
                                        </div>
                                    )}

                                {(this.props.history.location.pathname ===
                                    "/Home" ||
                                    this.props.history.location.pathname ===
                                    "/") && (
                                        <img
                                            src={logo}
                                            className="default test3"
                                            height="50"
                                            alt="logo"
                                        />
                                    )}
                            </a>
                        </div>

                        <div className="collapse navbar-collapse navbar-ex1-collapse">
                            <ul className="nav navbar-nav navbar-right">
                                {FrontEndRoutes.map((prop, key) => {
                                    if (!prop.redirect && prop.showMenu) {
                                        // console.log('prop.name', prop.path)
                                        if (
                                            User.isAuthenticated() &&
                                            prop.name === "Login"
                                        ) {
                                            return "";
                                        } else if (
                                            !User.isAuthenticated() &&
                                            prop.path === "/Dashboard"
                                        ) {
                                            return "";
                                        } else {
                                            return (
                                                <React.Fragment key={key}>
                                                    {window.localStorage
                                                        .user && (
                                                            <li>
                                                                <Link to="/Admin/dashboard">
                                                                    Dashboard
                                                            </Link>
                                                            </li>
                                                        )}
                                                    <li
                                                        key={key}
                                                        className={
                                                            prop.navClass
                                                                ? prop.navClass
                                                                : ""
                                                        }
                                                    >
                                                        {/* <Link to={prop.path.replace(/(\/:[\w]*\??)+/,'')} data-scroll="main_slider">
                                  {prop.name}
                                </Link> */}

                                                        <Link
                                                            to="/Admin-login"
                                                            data-scroll="main_slider"
                                                        >
                                                            Login
                                                        </Link>
                                                    </li>
                                                    <li
                                                        key={key}
                                                        className={
                                                            prop.navClass
                                                                ? prop.navClass
                                                                : ""
                                                        }
                                                    >
                                                        <Link
                                                            to="/customer-signup"
                                                            data-scroll="main_slider"
                                                        >
                                                            Signup
                                                        </Link>
                                                    </li>
                                                </React.Fragment>
                                            );
                                        }
                                    }
                                    return null;
                                })}
                                {User.isAuthenticated() && (
                                    <React.Fragment>
                                        {/* <li onClick={this.logout} className="pull-right"><a>{User.user.name}</a></li> */}
                                        {/* <li><Link to="/dashboard">Dashboard</Link></li> */}
                                    </React.Fragment>
                                )}
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
        );
    }
}

function mapStateToProps(state) {
    const { loading, User, loggedIn } = state.frontEndUserReducer;
    return {
        loading,
        User,
        loggedIn
    };
}
const Header = connect(mapStateToProps)(HeaderPage);
export default Header;



// WEBPACK FOOTER //
// ./src/components/FrontEnd/Header/Header.jsx